import React, { useEffect, useState } from 'react'
import {Line, Bar} from 'react-chartjs-2'
import numeral, {value} from 'numeral'
import './Linegraph.css'



    const options = {

        legend: 
        {
            display: false
        },
        elements:
         {
            point:
             {
                radius : 0,
             },
        },
        maintainAspectRatio: true,

        tooltips:
        {
            mode: "index",
            intersect: false,
            callbacks: 
            {
                label: function(tooltipItem , data)
                {
                    return numeral(tooltipItem,value).format("+0.0");
                },
            },
        },

        scales:
        {
            xAxes :
            [
                {
                    type: 'time',
                    time:
                     {
                         format: 'MM/DD/YY',
                         tooltipFormat: 'll',

                     },
                     labels: {
                         color: 'blue',
                     },
                },
            ],

            yAxes:
            [
                {
                    gridlines: {display: false,},
                    ticks:
                    {
                        color: 'blue',
                        callback: function(value, index,values)
                        {
                            return numeral(value).format("0a");
                        },
                    },
                },
            ],

        }, 
    
    };

    const buildChartData = (data, casesType= 'cases') => {
        let chartData = [];
        let lastDataPoint;

        for(let date in data.cases) //here we are declaring the variable data that is related to the number of new cases
        //that have been recorded on that specific day
        {
            if(lastDataPoint)
            {
                let newDataPoint = {
                    x: date, //our dataset has data on the x-axis and number of cases information on the y-axis
                    y: data[casesType][date] - lastDataPoint,
                };

                chartData.push(newDataPoint);
            }
            lastDataPoint = data[casesType][date];
        }
        return chartData;
    };

    function Linegraph(casesType = 'cases') {

    const [data, setData] = useState({});//here we want to make a call to the endpoint which shows
        // worldwide covid data of the last 120 days
    useEffect(() => {
        const fetchData = async() =>//the useEffect hook fetches the data from the disease.sh endpoint
        await fetch('https://disease.sh/v3/covid-19/historical/all?lastdays=120')
        .then(response => {
         return response.json();
         })

        .then((data) => {
            let chartData = buildChartData(data, 'cases');
            
            setData(chartData);
        });
        fetchData();
    }, [casesType]);

    //tooltips  appear when you hover over the gragh
    //and see the value representing new cases of that day


    return ( 
        <div>
            {data?.length > 0 && (
                <Line className='line'
                options={options}
                casesType={casesType}
                
                data= {{
                    datasets: [ 
                        {
                            data: data,
                            label: 'Covid Stats',
                            borderColor: "#CC1034",
                            backgroundColor:  "rgba(204,16,52,0.5)",
                            color: "blue",
                            fill: false
    
                        }

                    ],
                    
                    }}
                />

                )},

                {data?.length > 0 && (
                <Bar className='bar'

                options={options}

                data = {{
                datasets: [
                  {
                    data: data,
                    label: "Covid Stats", 
                    borderColor: "#CC1034",
                    backgroundColor: "rgba(204,16,52,0.5)",
                    borderRadius: 1,
                    borderWidth: 3,
                    fill: false,
                  },
                ],
             }}
                />
                )}
                 
        </div>
    );

        }
export default Linegraph
